import React from 'react';
import PartnerList from '../components/partner-network/PartnerList';

const PartnersPage: React.FC = () => <PartnerList />;

export default PartnersPage;
